import React from 'react';

export default (props) => (
  <footer className="site-footer">
    <button
      type="button"
      className="footer-link"
      onClick={() => props.onImprint && props.onImprint()}
    >
      imprint
    </button>
    <button
      type="button"
      className="footer-link"
      onClick={() => props.onGdpr && props.onGdpr()}
    >
      gdpr
    </button>
  </footer>
);
